
import React from 'react';
import MonitoringFeature from '../features/monitoring/Monitoring';

const MonitoringPage: React.FC = () => {
    return <MonitoringFeature />;
};

export default MonitoringPage;
